import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { HOME_PATH } from '../../constants/routes';
import CheckboxComponent from '../core/CheckboxComponent/CheckboxComponent';
import ModalComponent from '../core/ModalComponent/ModalComponent';

import './adminPage.scss';

class AdminPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            companies: null,
            checked: [],
            modalConfirmButtonTitle: '',
            modalBody: '',
            modalTitle: '',
            showModal: false,
        }
    }

    componentWillMount() {
        this.fetchPendingCompanies();
    }

    handleRefresh = () => {
        this.setState({
            buttonActive: false,
        }, () => {
            this.fetchPendingCompanies();
        });
    }

    fetchPendingCompanies = () => {
        const { getPendingFacilitiesAdmin } = this.props;

        let temp = getPendingFacilitiesAdmin();
        temp.then(function(result) {
            this.setState({
                companies: result,
                buttonActive: true,
                checked: [],
            });
        }.bind(this));
    }

    handleSubmit = (companyId, licenseId, env, consumerKey, action, additional) => {
        let facilities = this.state.checked[companyId + '/' + env + '/' + licenseId] ? (Object.keys(this.state.checked[companyId + '/' + env + '/' + licenseId])) : [];
        this.setState({
            showModal: true,
            modalConfirmButtonTitle: action.charAt(0).toUpperCase() + action.slice(1),
            modalTitle: action,
            modalBody: <div><div>Are you sure you want to {action} these facilities?</div><br /><ul>{facilities.map(facility => { return <li key={facility}>{facility}</li> })}</ul></div>,
            companyIdSaved: companyId,
            licenseIdSaved: licenseId,
            envSaved: env,
            consumerKey: consumerKey,
            action: action,
            additionalSaved: additional,
        });
    }

    action = () => {
        let { companyIdSaved, licenseIdSaved, envSaved, consumerKey, action, additionalSaved } = this.state;
        let companies = JSON.parse(JSON.stringify(this.state.companies));
        let temp = companies[companyIdSaved];
        let facilities = this.state.checked[companyIdSaved + '/' + envSaved + '/' + licenseIdSaved] ? (Object.keys(this.state.checked[companyIdSaved + '/' + envSaved + '/' + licenseIdSaved]).join(',')) : '';
        let remainingFacilities = temp[envSaved.toLowerCase()][licenseIdSaved].facilities.split(',').filter((facility) => !facilities.includes(facility));
        temp[envSaved.toLowerCase()][licenseIdSaved].facilities = remainingFacilities.join(',');
        let checkedTemp = this.state.checked;
        let errorMsg = '';
        this.props.updatePendingFacilities(companyIdSaved, licenseIdSaved, envSaved, companies[companyIdSaved], facilities, action, consumerKey, additionalSaved).then((response) => {
            if (response === 'OK') {
                delete checkedTemp[companyIdSaved + '/' + envSaved + '/' + licenseIdSaved];
                if (temp[envSaved.toLowerCase()][licenseIdSaved].facilities === '') {
                    delete temp[envSaved.toLowerCase()][licenseIdSaved];
                    if (Object.keys(temp[envSaved.toLowerCase()]).length === 0) {
                        delete temp[envSaved.toLowerCase()];
                        if (!temp.dev && !temp.prod) {
                            delete companies[companyIdSaved];
                        }
                    }
                }
            } else {
                errorMsg = response;
                companies = JSON.parse(JSON.stringify(this.state.companies));
            }
            this.setState({
                companies: companies,
                checked: checkedTemp,
                showModal: false,
                error: errorMsg,
            });
        });
    }

    render() {
        const { user } = this.props;
        const { companies, checked, buttonActive, submitting, modalConfirmButtonTitle, modalBody, modalTitle, showModal, licenseIdSaved, envSaved, error } = this.state;

        if (user && !!user.uid && !user.admin) {
            return <Redirect to={HOME_PATH} />;
        }

        let companyCount = -1;

        return <div className='admin-container'>
            {user && !!user.uid && user.admin &&
                <div>
                    <Button className="btn btn-default refresh" disabled={!buttonActive} onClick={this.handleRefresh}>Refresh</Button>
                    {companies && Object.keys(companies).length > 0 && Object.keys(companies).map((companyId) => {
                        companyCount++;
                        let company = companies[companyId];
                        return <div key={company.companyName} className='company-container'>
                            <div className='company-header'>{company.companyName} ({companyId}) [{company.backendId}]</div>
                            <div className='company-contact'>Contact: {company.userName} ({company.userEmail})</div>
                            {company.dev &&
                                <div className='env-container'>
                                    <div className='env-header'>DEV:</div>
                                    {Object.keys(company.dev).map((licenseId) => {
                                        let license = company.dev[licenseId];
                                        return <div key={licenseId} className='license-container'>
                                            <div className='license-header'>{license.licenseName} ({licenseId})</div>
                                            <div className='license-callbacks'><b>Callbacks:</b></div>
                                            {license.callbacks.length > 0 && <ul>
                                                {license.callbacks.split(',').map(callback => {
                                                    return <li key={licenseId + callback}>{callback}</li>
                                                })}
                                            </ul>}
                                            <div className='license-additional'><b>Additional Functionality:</b></div>
                                            {license.additional && license.additional.length > 0 && <ul>
                                                {license.additional.split(',').map(functionality => {
                                                    return <li key={licenseId + functionality}>{functionality}</li>
                                                })}
                                            </ul>}
                                            <div className='license-facilities'><b>Facilities:</b></div>
                                            {license.facilities.split(',').map((facilityId) => {
                                                return <div key={licenseId + facilityId} className='facility-container'>
                                                    {facilityId}
                                                    <CheckboxComponent
                                                        name={`${facilityId}Checkbox`}
                                                        checked={this.state.checked[companyId + '/DEV/' + licenseId] && this.state.checked[companyId + '/DEV/' + licenseId][facilityId]}
                                                        onChange={() => {
                                                            let temp = this.state.checked;
                                                            if (!temp[companyId + '/DEV/' + licenseId]) {
                                                                temp[companyId + '/DEV/' + licenseId] = {};
                                                            }

                                                            if (!temp[companyId + '/DEV/' + licenseId][facilityId]) {
                                                                temp[companyId + '/DEV/' + licenseId][facilityId] = true;
                                                            } else {
                                                                delete temp[companyId + '/DEV/' + licenseId][facilityId];
                                                            }

                                                            this.setState({
                                                                checked: temp,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            })}
                                            {(licenseIdSaved === licenseId) && (envSaved === 'dev') &&
                                                <div className='error'>{error}</div>
                                            }
                                            <div className='license-buttons'>
                                                <Button className="btn btn-default approve" disabled={!checked[companyId + '/DEV/' + licenseId] || Object.keys(checked[companyId + '/DEV/' + licenseId]).length === 0} onClick={() => this.handleSubmit(companyId, licenseId, 'DEV', license.consumerKey, 'approve', license.additional)}>Approve Selected</Button>
                                                <Button className="btn btn-default deny" disabled={!checked[companyId + '/DEV/' + licenseId] || Object.keys(checked[companyId + '/DEV/' + licenseId]).length === 0} onClick={() => this.handleSubmit(companyId, licenseId, 'DEV', license.consumerKey, 'deny', license.additional)}>Deny Selected</Button>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            }
                            {company.prod &&
                                <div className='env-container'>
                                    <div className='env-header'>PROD:</div>
                                    {Object.keys(company.prod).map((licenseId) => {
                                        let license = company.prod[licenseId];
                                        return <div key={licenseId} className='license-container'>
                                            <div className='license-header'>{license.licenseName} ({licenseId})</div>
                                            <div className='license-callbacks'><b>Callbacks:</b></div>
                                            {license.callbacks.length > 0 && <ul>
                                                {license.callbacks.split(',').map(callback => {
                                                    return <li key={licenseId + callback}>{callback}</li>
                                                })}
                                            </ul>}
                                            <div className='license-facilities'><b>Facilities:</b></div>
                                            {license.facilities.split(',').map((facilityId) => {
                                                return <div key={licenseId + facilityId} className='facility-container'>
                                                    {facilityId}
                                                    <CheckboxComponent
                                                        name={`${facilityId}Checkbox`}
                                                        checked={this.state.checked[companyId + '/PROD/' + licenseId] && this.state.checked[companyId + '/PROD/' + licenseId][facilityId]}
                                                        onChange={() => {
                                                            let temp = this.state.checked;
                                                            if (!temp[companyId + '/PROD/' + licenseId]) {
                                                                temp[companyId + '/PROD/' + licenseId] = {};
                                                            }

                                                            if (!temp[companyId + '/PROD/' + licenseId][facilityId]) {
                                                                temp[companyId + '/PROD/' + licenseId][facilityId] = true;
                                                            } else {
                                                                delete temp[companyId + '/PROD/' + licenseId][facilityId];
                                                            }

                                                            this.setState({
                                                                checked: temp,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            })}
                                            {(licenseIdSaved === licenseId) && (envSaved === 'prod') &&
                                                <div className='error'>{error}</div>
                                            }
                                            <div className='license-buttons'>
                                                <Button className="btn btn-default approve" disabled={!checked[companyId + '/PROD/' + licenseId] || Object.keys(checked[companyId + '/PROD/' + licenseId]).length === 0} onClick={() => this.handleSubmit(companyId, licenseId, 'PROD', license.consumerKey, 'approve', license.additional)}>Approve Selected</Button>
                                                <Button className="btn btn-default deny" disabled={!checked[companyId + '/PROD/' + licenseId] || Object.keys(checked[companyId + '/PROD/' + licenseId]).length === 0} onClick={() => this.handleSubmit(companyId, licenseId, 'PROD', license.consumerKey, 'deny', license.additional)}>Deny Selected</Button>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            }
                            {companyCount < Object.keys(companies).length - 1 && <hr />}
                        </div>
                    })}
                    {(!companies || Object.keys(companies).length === 0) &&
                        <div className='blank'>No pending facilities currently exist.</div>
                    }
                </div>
            }
            <ModalComponent
                show={showModal}
                handleClose={() => this.setState({ showModal: false })}
                title={modalTitle}
                body={modalBody}
                cancelButtonTitle={'Cancel'}
                confirmButtonTitle={modalConfirmButtonTitle}
                onConfirm={this.action}
                pages={1}
                page={1}
                submitting={submitting}
                setSubmitting={(val) => this.setState({ submitting: val })}
            />
        </div>;
    }
}

AdminPageComponent.propTypes = {
    user: PropTypes.object.isRequired,
    getPendingFacilitiesAdmin: PropTypes.func.isRequired,
    updatePendingFacilities: PropTypes.func.isRequired,
};

export default AdminPageComponent;



// WEBPACK FOOTER //
// ./src/components/admin/AdminPageComponent.js